/**
 * 整個頁面遮罩的 loading component
 *
 */

import loadingSvg from '../../assets/images/loading.svg';
import loadingSmallSvg from '../../assets/images/loading-small.svg';

/**
 * @param {object} props
 * @param {number} props.backgroundAlpha 遮罩背景透明度
 * @param {boolean} props.isLoadingText 是否顯示文字
 * @param {string} props.loadingText 顯示的文字
 * @param {boolean} props.maskAll 遮住整個頁面，透明度為 1
 */
function PageLoading({
  backgroundAlpha = 0.25,
  isLoadingText = false,
  loadingText = 'LOADING...',
  maskAll = false,
}) {
  return (
    <div
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: maskAll ? 1000 : 999,
        background: maskAll ? 'rgba(240, 242, 245, 1)' : `rgba(0 ,0, 0, ${backgroundAlpha})`,
        position: 'fixed',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <img
          alt="loading"
          src={maskAll ? loadingSvg : loadingSmallSvg}
          style={{ zIndex: maskAll ? 1000 : 999 }}
        />
        {isLoadingText && (
          <p
            style={{
              margin: '0px',
              padding: '0px',
              letterSpacing: '3px',
              color: '#0055a5',
            }}
          >
            {loadingText}
          </p>
        )}
      </div>
    </div>
  );
}

export default PageLoading;
